export class PagedFilterDTO {
  name: string;
  operator: string;
  value: string;
}

export class PagedFilterDTONew {
  name: string;
  operator: string;
  value: string;
  logicGate: string;
  bracket: string;
}
